export const CRM_API = {
  app: {
    base: '/app',
    layout: '/layout',
    emrLink: '/emr-link'
  },
  settings: {
    base: '/settings'
  },
  appointments: {
    base: '/appointments',
    single: ':id',
    assignProvider: '/:id/provider',
    availableProviders: '/available-providers'
  },
  auth: {
    base: '/auth',
    register: '/register'
  },
  users: {
    base: '/users',
    lookups: '/lookups',
    single: '/:id',
    password: '/password',
    getCurrent: '/current',
    permissions: '/permissions',
    schedule: '/schedule'
  },
  leads: {
    base: '/leads',
    lookups: '/lookups',
    single: '/:id',
    singleFile: '/:id/files/:fileName',
    uploadFile: '/:id/files',
    singleConvert: '/:id/convert',
    emrDemographic: '/emr/demographic',
    exportCsv: '/export/csv'
  },
  customers: {
    base: '/customers',
    lookups: '/lookups',
    single: '/:id'
  },
  tasks: {
    base: '/tasks',
    single: '/tasks'
  },
  notifications: {
    base: '/notifications',
    dismissAll: '/dismiss-all',
    dismissSingle: '/:id/dismiss'
  },
  services: {
    base: '/services',
    lookups: '/lookups',
    single: '/:id',
    singleDisable: '/:id/disable',
    schedules: '/:id/schedules',
    scheduleSingle: '/:id/schedules/:scheduleId',
    singleServiceAvailabilityV2: '/:id/availability-v2'
  },
  forms: {
    base: '/forms',
    lookups: '/lookups',
    single: '/:id',
    singleByName: '/name/:name'
  },
  schedules: {
    base: '/schedules',
    lookups: '/lookups',
    single: '/:id',
    sync: '/:id/sync'
  },
  recurringTasks: {
    base: '/recurring-tasks',
    lookups: '/lookups'
  },
  layouts: {
    base: '/layouts',
    single: '/:id',
    singleByName: '/name/:name'
  },
  segments: {
    base: '/segments',
    lookups: '/lookups',
    single: '/:id'
  },
  campaigns: {
    base: '/campaigns',
    single: '/:id',
    launch: '/:id/launch'
  },
  workflows: {
    base: '/workflows',
    lookups: '/lookups',
    single: '/:id',
    singleByName: '/name/:name',
    singleTest: '/:id/test',
    adapters: '/adapters'
  },
  workflowRuns: {
    base: '/workflows-runs',
    single: '/:id'
  },
  crmSchema: {
    base: '/crm-schema',
    single: '/:id',
    singleByName: '/name/:name'
  },
  config: {
    base: '/config',
    auth: {
      stripeConnectToken: 'auth/stripe-connect-token'
    }
  },
  emailTemplates: {
    base: '/email-templates',
    single: '/:id',
    clone: '/clone',
    test: '/test',
    lookups: '/lookups'
  },
  products: {
    base: '/products',
    single: '/:id',
    fileSingle: '/:id/files/:fileName',
    uploadFile: '/:id/files',
    lookups: '/lookups'
  },
  productCategories: {
    base: '/product-categories',
    single: '/:id',
    lookups: '/lookups'
  },
  orderStats: {
    base: '/order-stats'
  },
  coupons: {
    base: '/coupons'
  },
  promotions: {
    base: '/promotions'
  },
  pharmacies: {
    base: '/pharmacies',
    single: '/:id'
  },
  dashboard: {
    base: '/dashboard',
    ordersKpi: '/orders-kpi',
    subscriptionsKpi: '/subscriptions-kpi',
    ordersFunnel: '/orders-funnel',
    topCustomersBySpend: '/top-customers-by-spend',
    topProductsByRevenue: '/top-products-by-revenue',
    topProductsByOrders: '/top-products-by-orders',
    patientJourney: '/patient-journey'
  },
  analytics: {
    base: '/analytics',
    dashboard: '/dashboard',
    kpis: {
      orders: '/kpis/orders',
      subscriptions: '/kpis/subscriptions'
    },
    funnels: {
      orders: '/funnels/orders'
    },
    top: {
      customers: '/top/customers',
      products: '/top/products',
      categories: '/top/categories'
    },
    journeys: {
      patient: '/journeys/patient'
    }
  },
  analyticsV2: {
    base: '/analytics/v2',
    dashboard: '/dashboard',
    kpis: {
      orders: '/kpis/orders',
      subscriptions: '/kpis/subscriptions'
    },
    funnels: {
      orders: '/funnels/orders'
    },
    top: {
      customers: '/top/customers',
      products: '/top/products',
      categories: '/top/categories'
    },
    journeys: {
      patient: '/journeys/patient'
    }
  }
};
